module dg.restfulApi {
    import ListQueryResult = dg.domain.queries.ListQueryResult;
    import ModelQueryResult = dg.domain.queries.ModelQueryResult;

    export class RestfullApiClientService {

        private domainTypesMetadata: { [id: string]: DomainTypeMetadata };
        //private restangularRequest: Restangular.IService;
        private baseUrl: string;

        public constructor(
            private $q: ng.IQService,
            private $http: ng.IHttpService,
            private apiSettings: dg.restfulApi.ApiSettings,
            private clientInfoService: dg.clients.ClientInfoService,
            public $window: ng.IWindowService
        ) {

            this.domainTypesMetadata = {};

            this.baseUrl = '/';
            //this.restangularRequest = Restangular.withConfig(RestangularConfigurer => {
            //    RestangularConfigurer.setBaseUrl('/');
            //    RestangularConfigurer.setDefaultHeaders({
            //        accept: 'application/dma+json'
            //    });
            //});
        }
        public hostReachable() {

            // Handle IE and more capable browsers
            var xhr = new (this.$window.ActiveXObject || XMLHttpRequest)("Microsoft.XMLHTTP");
            var status;

            // Open new request as a HEAD to the root hostname with a random param to bust the cache
            xhr.open("HEAD", "//" + this.$window.location.hostname + "/?rand=" + Math.floor((1 + Math.random()) * 0x10000), false);

            // Issue request and handle response
            try {
                xhr.send();
                return (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304);
            } catch (error) {
                return false;
            }

        }

        public mergeActionMetadata(action: dg.domain.actions.IDomainAction) {

            let deferred = this.$q.defer<dg.domain.actions.IDomainAction>();

            this.loadDomainTypeMetadata(action.dgMeta).then(() => {

                action.dgMeta = this.mergeMetadata(action.dgMeta);

                deferred.resolve(action);
            }, deferred.reject);

            return deferred.promise;
        }

        
        public mergeModelQueryResultMetadata(model: dg.domain.IDomainObject) {

            let deferred = this.$q.defer<dg.domain.IDomainObject>();

            this.loadDomainTypeMetadata(model.dgMeta).then(() => {

                model = this.mergeMetadataWithChildObjects(model);

                deferred.resolve(model);
            }, deferred.reject);

            return deferred.promise;
        }

        public mergeListQueryResultMetadata(result: ListQueryResult<dg.domain.IDomainObject>) {

            let defered = this.$q.defer<ListQueryResult<dg.domain.IDomainObject>>();

            this.loadDomainTypeMetadata(result.dgMeta).then(() => {

                result = this.mergeArrayMetadata(result);

                defered.resolve(result);
            }, defered.reject);

            return defered.promise;
        }

        public mergeArrayMetadata(result: ListQueryResult<dg.domain.IDomainObject>) {
            result.dgMeta = this.mergeMetadata(result.dgMeta, true);
            for (let item of result.items) {
                item.dgMeta = this.mergeMetadata(item.dgMeta, false);
            }
            return result;
        }


        public mergeMetadataWithChildObjects(model) {
            model.dgMeta = this.mergeMetadata(model.dgMeta);

            for (let propName in model.dgMeta.properties) {
                let propMeta = <DomainObjectPropertyMetadata>model.dgMeta.properties[propName];

                if (propMeta.propertyType == "ChildObject") {
                    if (propMeta.multiple) {
                        //TODO: is this correct 
                        //Skip merge of child array because it changes the object structure
                        //model[propName] = this.createChildQueryResult(<dg.domain.IDomainObject[]>model[propName], propMeta)
                    } else {
                        this.mergeMetadataWithChildObjects(model[propName]);
                    }
                }
            }

            return model;
        }

        public mergeMetadata(dgMeta: DomainObjectMetadata, shouldMergeLinks?: boolean) {
            if (dgMeta != undefined) {
                if (shouldMergeLinks == undefined) {
                    shouldMergeLinks = true;
                }
                let typeMetadata = this.getChildDomainTypeMetadata(dgMeta.id);
                let mergedMeta = this.metadataObjectMerge(typeMetadata, dgMeta, shouldMergeLinks);

                return mergedMeta;
            }
        }

        public getChildDomainTypeMetadata(childDomainTypeId: string) {
            return dgUtils.ObjectHelperService.mergeDeep({}, this.domainTypesMetadata[childDomainTypeId]);
        }

        public loadDomainTypeMetadata(dgMeta: DomainObjectMetadata) {

            let deferred = this.$q.defer();

            if (!this.isIndexed(dgMeta.id)) {
                var metaLinkId = dgMeta.id + '_metadata';
                var metaLink = dgMeta.links[metaLinkId];

                this.get(metaLink.href).then(
                    //this.createOneReqeustFromLink(metaLink.href).get().then(
                    (result: ng.IHttpResponse<dg.restfulApi.SuccessResult>) => {
                        this.indexDomainTypes(result.data.value.domainTypes);
                        deferred.resolve();
                    }, deferred.reject);
            } else {
                deferred.resolve(this.getChildDomainTypeMetadata(dgMeta.id));
            } 
            return deferred.promise;
        }

        isIndexed(domainTypeId: string): boolean {
            return angular.isDefined(this.domainTypesMetadata[domainTypeId]);
        }

        indexDomainTypes(domainTypes: { [id: string]: DomainTypeMetadata; }) {
            for (var dtId in domainTypes) {
                if (!this.isIndexed(dtId)) {
                    this.domainTypesMetadata[dtId] = domainTypes[dtId];
                }
            }
        }

        metadataObjectMerge(typeMeta: DomainTypeMetadata, dgMeta: DomainObjectMetadata, shouldMergeLinks?: boolean): DomainObjectMetadata {
            if (dgMeta.isMerged) {
                return dgMeta;
            }

            if (dgMeta.properties) {
                let propNames = Object.keys(dgMeta.properties);
                this.removeNotDefiedProperties(propNames, dgMeta);

                if (typeMeta) {
                    this.removeNotDefiedProperties(propNames, typeMeta);
                }
            }

            if (typeMeta) {
                if (shouldMergeLinks == false) {
                    typeMeta.links = null;
                }
                dgMeta = <DomainObjectMetadata>dgUtils.ObjectHelperService.mergeDeep(typeMeta, dgMeta);
            }

            dgMeta.isMerged = true;
            return dgMeta;
        }

        private removeNotDefiedProperties(propNames: string[], dgMeta: dg.restfulApi.DomainObjectMetadata) {
            propNames.forEach(propName => {
                if (Object.keys(dgMeta.properties).length > 0 && dgMeta.properties[propName].notDefined) {
                    dgMeta.properties[propName] = null;
                }
            });
        }

        public get(href: string, queryParams?: any) {
            //let deferred = this.$q.defer();
            let hasQueryParams: boolean = false;
            if (queryParams) {
                hasQueryParams = true;
            }

            let req = this.createGetRequest(href, hasQueryParams);
            req.params = queryParams;

            return this.$http(req);

            //return deferred.promise;
        }

        public post(href: string, data: any) {
            let deferred = this.$q.defer();

            let req = this.createPostRequest(href, data);

            this.$http(req).then(result => {
                //let successResult: SuccessResult = result
                deferred.resolve(result);
            }, (error: ErrorResult) => {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        //public propertyLookupData(propMeta: DomainObjectPropertyMetadata): restangular.IElement {
        //    return this.restangularRequest.all(propMeta.links.lookupResult.href.substr(1));
        //}

        public createOneReqeust(href: string, method, hasQueryParams?: boolean): any {
            href = this.fixAbsoluteLink(href, hasQueryParams);
            let req = {
                url: href,
                method: method,
                headers: {
                    'Accept': 'application/dma+json'
                }

            };

            return req;
        }

        public createGetRequest(href: string, hasQueryParams?: boolean) {
            return this.createOneReqeust(href, 'GET', hasQueryParams);
        }

        public createPostRequest(href: string, data: any, hasQueryParams?: boolean) {
            let req = this.createOneReqeust(href, 'POST', hasQueryParams);
            req.data = data;

            return req;
        }



        public getStaticFile(fileLocation) {
            return this.$http({
                method: 'GET',
                url: fileLocation,
            });
        }

        public executeExternalDownload(externalHref: string, mediaType: string): any {

            return this.$http({
                method: 'GET', 
                url: externalHref,
                headers: {
                    Accept: mediaType//'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'blob'
            });
        }

        public executeExportFromQuery(link: Link, queryParams: any): ng.IPromise<any> {
            let deferred = this.$q.defer();
            let url = this.fixAbsoluteLink(link.href)
            this.$http({
                method: 'GET',
                url: url,
                params: queryParams,
                headers: {
                    Accept: link.mediaType//'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'blob'
            }).then(result => {
                deferred.resolve(result);
            }, (error: ErrorResult) => {
                deferred.reject(error);
                });

            return deferred.promise;
        }

        fixAbsoluteLink(href: string, hasQueryParams?: boolean) {

            //fix url prefix
            if (href.indexOf('/api') != 0) {

                //if (href.indexOf('/{ownerId}') != 0) {
                //    href = '/{ownerId}' + href;
                //}

                href = '/api/v' + this.apiSettings.version + href;
            }

            //href = href.replace('{ownerId}', this.clientInfoService.getClientInfoResolved().clientId);
            ////href = href.substr(1);

            href = href.replace(/([^:]\/)\/+/g, "$1");

            if (hasQueryParams && href[href.length - 1] == '/') {
                href = href.substr(0, href.length - 1);
            }

            return href;
        }

       
    }

    angular.module('dg.restfulApi')
        .service('restfullApiClientService', RestfullApiClientService);
}